import { PhoneNumberDto } from "../../autogen/bff-api";
import { PhoneNumberInput } from "./PhoneNumberInput";

type CallingCode = { countryAlpha3Code: string; value: string; countryName: string };

export const phoneNumberDtoToInput = (
  phoneNumber: PhoneNumberDto | null | undefined,
  callingCodes: CallingCode[]
): PhoneNumberInput | null => {
  if (!phoneNumber) return null;
  const callingCode = callingCodes.find((c) => c.countryAlpha3Code === phoneNumber.callingCode.countryAlpha3Code);
  return {
    number: phoneNumber.number,
    country: {
      name: callingCode?.countryName ?? "",
      alpha3Code: callingCode?.countryAlpha3Code ?? "",
      callingCode: callingCode?.value ?? "",
    },
  };
};

export const phoneNumberInputToDto = (input: PhoneNumberInput | null): PhoneNumberDto | undefined =>
  input
    ? {
        callingCode: {
          countryAlpha3Code: input.country?.alpha3Code ?? "",
          value: input.country?.callingCode ?? "",
          countryName: input.country?.name ?? "",
        },
        number: input.number,
      }
    : undefined;
